<app-loading-overlay
  [show]="(processRouteLoading$ | async) === true"
  id="app-a3af7f-app-loading-overlay-process-route-0000"
></app-loading-overlay>
<router-outlet #appContainer id="app-a3af7f-router-outlet-node-0001"></router-outlet>
